import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=23239d3e&scoped=true"
import script from "./ChatConversation.vue?vue&type=script&lang=js"
export * from "./ChatConversation.vue?vue&type=script&lang=js"
import style0 from "./ChatConversation.vue?vue&type=style&index=0&id=23239d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23239d3e",
  null
  
)

export default component.exports